<template>
  <el-dialog
      :visible.sync="visible"
      title="库存初始化导入"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0px">
        <div class="bar-item">
          <UploadButton url="/erp/excel/file/store/init" @success="readFileSuccess" :params="{productType: productType}"></UploadButton>
        </div>
        <FileLink file-type="front" file-url="/static/template/成品库初始化模板.xlsx" class="bar-item" v-if="productType==='产品'">下载模板
        </FileLink>
        <FileLink file-type="front" file-url="/static/template/原料库初始化模板.xlsx" class="bar-item" v-if="productType==='原料'">下载模板
        </FileLink>
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['totalAmount','totalCount']" :row-style="rowStyleHandler">
        <el-table-column label="外销合同号" prop="agreementCode" align="center"></el-table-column>
        <el-table-column label="结算单号" prop="batchCode" align="center"></el-table-column>
        <el-table-column
            label="供应商"
            prop="senderName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column
            label="仓库名称"
            prop="receiverName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column label="品番号" prop="product.code" v-if="productType==='产品'"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="SKU" prop="product.skuCode" v-if="productType==='产品'"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="品名" prop="product.name"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="颜色" prop="product.color"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="规格" prop="product.size"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="幅宽" prop="product.attr1" v-if="productType==='原料'"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="克重" prop="product.attr2" v-if="productType==='原料'"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="发货数量" prop="sendCount"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="入库时间" width="120" prop="operateTime" align="center">
        </el-table-column>
        <el-table-column
            label="错误提示"
            prop="errorMsg"
            header-align="center"
            align="center" :show-overflow-tooltip="true">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="doSave" :disabled="!canSubmit">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import debounce from 'lodash/debounce'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import ImportErrorCard from '@/components/ImportErrorCard.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'InitImportDialog',
  components: { FileLink, ProductRowCard, UploadButton },
  data () {
    return {
      visible: false,
      dataForm: {},
    }
  },
  props: {
    productType: {
      type: String,
      default: '产品'
    }
  },
  computed: {
    dataRule () {
      return {}
    },
    canSubmit () {
      if (!this.dataForm || !this.dataForm.detailList) {
        return false
      }
      let hasError = this.dataForm.detailList.every(item => !item.errorMsg)
      return hasError
    }
  },
  methods: {
    rowStyleHandler ({ row, rowIndex }) {
      if (row.errorMsg) {
        return {
          color: 'red'
        }
      }
    },
    readFileSuccess (result) {
      this.dataForm.detailList = result
    },
    init (detailList) {
      this.dataForm = {
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = []
      this.dataForm.detailList.forEach(row => {
        postForm.push({
          ...row,
          agreementId:row.orderId
        })
      })
      const loading = this.$loading()
      try {
        const res = await this.$api2.post('/erp/store/init/import', postForm)
        this.$emit('changed')
        this.visible = false
        this.dataForm.detailList = []
      } finally {
        loading.close()
      }
    }
  },
}
</script>

